import { render, staticRenderFns } from "./educacionNoFormal.vue?vue&type=template&id=026db4ac"
import script from "./educacionNoFormal.vue?vue&type=script&lang=js"
export * from "./educacionNoFormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports